async function get2FAToken() {
  const COOKIE_2FA = '2FA_' + getCustomerId();
  var accessToken = readCookie(COOKIE_2FA);
  if (!accessToken) {
    var requestToken = undefined;
    var body = undefined;
    accessToken = await new Promise(async (resolve, reject) => {
      function onConfirm() {
        SMMFetch('POST', '/2fa/redeem', {
          token: requestToken,
          code: body.querySelector('#SMSCode').value,
        }).then(
          data => resolve(data.token),
          error => show(error.message),
        );
      }
      function onCancel() {
        reject('Cancelled');
      }
      function show(error) {
        body = showPopupQuery({
          name: 'general',
          data: undefined,
          headerText: 'We sent you a 6 digit code!',
          bodyHtml: `<p>Please enter the 6 digit code sent to your <strong>phone</strong>. This code may take a
            moment to arrive and will expire in 15 minutes.<br/><br/>If you can no longer access
            the number we have on file, please contact us.</p>
            ${error ? `<p class="error--text">${error}</p>` : ''}
            <div class="field">
                <input class="field__input"
                    type="text"
                    maxlength="6"
                    id="SMSCode"
                    name="code"
                    value=""
                    placeholder="Code"></input>
                <label class="field__label" for="SMSCode">Code</label>
            </div>
            <button id="resend-code" class="link">Resend code</button>`,
          onConfirm,
          onCancel,
          isNotification: true,
          confirmText: 'Submit',
        }).body;
        body.querySelector('#resend-code').onclick = send;
      }
      function send() {
        showPopupQuery({
          name: 'general',
          headerText: 'Sending code...',
          bodyHtml: '<div style="height:100px; position:relative;" class="changing"><div class="spinner"></div></div>',
          isNotification: true,
          enableConfirm: false,
          confirmText: 'Continue',
        });
        SMMFetch('GET', '/2fa').then(
          data => {
            requestToken = data.token;
            show();
          },
          error => {
            showPopupQuery({
              name: 'general',
              data: undefined,
              headerText: 'Unable to authenticate',
              bodyHtml: error.message,
              onConfirm: send,
              onCancel,
              confirmText: 'Retry',
              cancelText: 'Done',
            });
          },
        );
      }
      send();
    });

    if (accessToken) setCookie(COOKIE_2FA, accessToken, 0.95);
  }
  return accessToken;
}

window.get2FAToken = get2FAToken;
